<template>
  <div>
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="远程类型">
        <el-select
          v-model="formInline.user_type"
          placeholder="请选择远程类型"
          clearable
        >
          <el-option label="全部" value=""></el-option>
          <el-option label="远程UI" value="2"></el-option>
          <el-option label="远程运营" value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="任务类型">
        <el-select
          v-model="formInline.work_type"
          placeholder="请选择任务类型"
          clearable
        >
          <el-option label="全部" value=""></el-option>
          <el-option label="封面创作" value="1"></el-option>
          <el-option label="打点" value="2"></el-option>
          <el-option label="富文本" value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="时间范围">
        <el-date-picker
          v-model="create_time_form"
          type="daterange"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>

      <el-button @click="search" :loading="loading">查询</el-button>
      <el-button @click="refesh">刷新</el-button>
    </el-form>
    <!-- :cell-class-name="cellClassName" -->
    <el-table
      :data="tableData"
      border
      style="width: 100%"
      v-loading="loading"
      element-loading-text="加载中"
      element-loading-spinner="el-icon-loading"
      @cell-click="handleCellClick"
    >
      <el-table-column
        prop="nick_name"
        label="用户昵称"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="filling_count"
        label="填充待完成数量"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="point_count"
        label="打点待完成数量"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="over_count"
        label="完成数量"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="reject_count"
        label="需重做数量"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="fill_failed_count"
        label="封面数量"
        align="center"
      ></el-table-column>
      <el-table-column prop="work_type" label="任务类型" align="center">
        <template slot-scope="scope">
          {{
            {
              0: "无",
              1: "封面创作",
              2: "打点",
              3: "富文本",
            }[scope.row.work_type] || "无"
          }}
        </template>
      </el-table-column>
      <!-- <el-table-column prop="create_time" label="创建时间" align="center">
        <template slot-scope="scope">
          {{ (scope.row.create_time * 1000) | changeDate }}
        </template>
      </el-table-column> -->
      <!-- <el-table-column fixed="right" label="操作" align="center" width="140">
        <template slot-scope="scope">
          <el-button @click="toVideo(scope.row)" type="text" size="small"
            >查看</el-button
          >
          <el-button
            type="text"
            @click="edit(scope.row)"
            v-has="'/api/actor/update'"
            size="small"
            >编辑</el-button
          >
          <el-button
            type="text"
            @click="deleteData(scope.row)"
            v-has="'/api/actor/batch/delete'"
            size="small"
            >删除</el-button
          >
        </template>
      </el-table-column> -->
    </el-table>
    <div class="bottom">
      <div class="page">
        <el-pagination
          :page-sizes="[10, 25, 50, 100]"
          :current-page="formInline.page"
          :page-size="formInline.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          background
          v-if="total > 10"
          @size-change="changeSize"
          @current-change="changeCurrent"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import API from "@/api";

export default {
  name: "workstate",
  components: {},
  data() {
    // 获取今天的开始和结束时间，确保毫秒为000
    const today = new Date();
    const startOfDay = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0, 0);
    const endOfDay = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59, 0);
    
    return {
      addFrom: false,
      tableData: [],
      loading: false,
      disabled: false,
      formInline: {
        user_type: "2",
        work_type: "1",
        page: 1,
        size: 10,
      },
      dialogType: "add",
      data: {},
      total: 0,
      isRefesh: true,
      create_time_form: [startOfDay, endOfDay],
    };
  },
  created() {
    let listRule = "/api/auth/admin/user/workstate";
    let obj = JSON.parse(
      JSON.parse(JSON.stringify(localStorage.getItem("btnPower")))
    );
    if (obj[listRule]) {
      this.isRefesh = true;
      this.getDataList();
    } else {
      this.isRefesh = false;
    }
  },
  methods: {
    cellClassName({ column }) {
      // const clickableProps = [
      //   "filling_count",
      //   "point_count",
      //   "over_count",
      //   "reject_count",
      //   "cover_count",
      // ];
      // return clickableProps.includes(column.property) ? "clickable-cell" : "";
      console.log(column, 'column');
      return "";
    },
    handleCellClick(row, column) {
      console.log(row, column, 'row, column');
      return
      // if (column.property === "point_count") {
      //   this.$router.push({
      //     path: "/medium/videoMarking",
      //     query: {
      //       dictionary: 0,
      //     },
      //   });
      //   return;
      // }
      // if (column.property === "filling_count") {
      //   this.$router.push({
      //     path: "/medium/dataFill",
      //     query: {
      //       status: 0,
      //     },
      //   });
      //   return;
      // }
      // const otherProps = ["over_count", "reject_count"];
      // if (otherProps.includes(column.property)) {
      //   const goVideoMarking = Number(row.work_type) === 2;
      //   this.$router.push({
      //     path: goVideoMarking ? "/medium/videoMarking" : "/medium/dataFill",
      //     query: {
      //       status: column.property === "over_count" ? 1 : 2,
      //     },
      //   });
      // }
    },
    refesh() {
      this.isRefesh ? this.getDataList() : "";
    },
    async getDataList() {
      if (!this.isRefesh) return;
      this.loading = true;
      if (this.create_time_form) {
        let start = new Date(this.create_time_form[0]).getTime() / 1000;
        let end = new Date(this.create_time_form[1]).getTime() / 1000;
        this.formInline.start = start;
        this.formInline.end = end;
      } else {
        this.formInline.start = null;
        this.formInline.end = null;
      }
      const { data, code } = await API.authAdminUserWorkstate(this.formInline);
      console.log(data);
      if (!code) {
        this.tableData = data.list || [];
        this.total = data.count || 0;
        this.loading = false;
      } else {
        this.tableData = [];
        this.loading = false;
      }
    },
    edit(data, type) {
      this.addFrom = true;
      type ? (this.dialogType = "look") : (this.dialogType = "edit");
      this.data = JSON.parse(JSON.stringify(data));
      this.disabled = !!type;
    },
    search() {
      this.formInline.page = 1;
      this.getDataList();
    },
    closeAdd() {
      this.addFrom = false;
      this.getDataList();
    },
    async updateData(row) {
      await API.updateUser(row).then(() => {
        this.getDataList();
      });
    },
    clearData() {
      this.addFrom = false;
    },
    // 分页条数改变回调
    changeSize(size) {
      this.formInline.size = size;
      this.getDataList();
    },
    // 分页页码改变回调
    changeCurrent(number) {
      this.formInline.page = number;
      this.getDataList();
    },
    changeData(row) {
      let list = [];
      if (row.product) {
        list = row.product.map((v) => v.product_name);
      }
      return list.join(",");
    },
    toVideo(row) {
      this.$router.push(`/medium/video?actor_name=${row.name}`);
    },
    deleteData(row) {
      this.$confirm("确定删除该演员吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        API.deleteActor({
          ids: [row.id],
        }).then(() => {
          this.getDataList();
        });
      });
    },
  },
};
</script>

<style scoped>
.action-bar {
  display: flex;
}
:deep(.clickable-cell) {
  cursor: pointer;
  color: #409eff;
}
:deep(.clickable-cell:hover) {
  text-decoration: underline;
}
</style>
